import { render } from "./edit.vue?vue&type=template&id=af5cbf66&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=af5cbf66&lang=scss&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5cbf66"]])

export default __exports__